import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessKxBnpSapBuExportStatus: 'idle',
    startProcessKxBnpSapBuExportError: undefined as any,
    loadUserParamsProcessKxBnpSapBuExportStatus: 'idle',
    loadUserParamsProcessKxBnpSapBuExportError: undefined as any,

    processKxBnpSapBuExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessKxBnpSapBuExport = createAsyncThunk('processKxBnpSapBuExportSlice/startProcessKxBnpSapBuExport', async ({ processKxBnpSapBuExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessKxBnpSapBuExport/`,
        prepareData(processKxBnpSapBuExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessKxBnpSapBuExportStatus } = getState().processKxBnpSapBuExportSlice
        return startProcessKxBnpSapBuExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessKxBnpSapBuExport = createAsyncThunk('processKxBnpSapBuExportSlice/loadUserParamsProcessKxBnpSapBuExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessKxBnpSapBuExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessKxBnpSapBuExportStatus } = getState().processKxBnpSapBuExportSlice
        return loadUserParamsProcessKxBnpSapBuExportStatus !== 'pending'
    }
})

const ProcessKxBnpSapBuExportSlice = createSlice({
    name: 'processKxBnpSapBuExportSlice',
    initialState,
    reducers: {
        resetstartProcessKxBnpSapBuExport: (state) => {
            state.job = undefined
            state.startProcessKxBnpSapBuExportError = undefined
        },
        resetstartProcessKxBnpSapBuExportError: (state) => {
            state.startProcessKxBnpSapBuExportError = undefined
        },
        resetloadUserParamsProcessKxBnpSapBuExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessKxBnpSapBuExportError = undefined
        },
        resetloadUserParamsProcessKxBnpSapBuExportError: (state) => {
            state.loadUserParamsProcessKxBnpSapBuExportError = undefined
        },
        removeFromProcessKxBnpSapBuExportListById: (state, action) => {
            state.processKxBnpSapBuExportList = state.processKxBnpSapBuExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessKxBnpSapBuExportListByIds: (state, action) => {
            state.processKxBnpSapBuExportList = state.processKxBnpSapBuExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processKxBnpSapBuExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessKxBnpSapBuExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processKxBnpSapBuExportList = []
            state.startProcessKxBnpSapBuExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessKxBnpSapBuExport.pending, (state) => {
            state.startProcessKxBnpSapBuExportStatus = 'pending'
            state.startProcessKxBnpSapBuExportError = undefined
        })
        builder.addCase(startProcessKxBnpSapBuExport.fulfilled, (state, action) => {
            state.startProcessKxBnpSapBuExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessKxBnpSapBuExport.rejected, (state, action) => {
            state.startProcessKxBnpSapBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessKxBnpSapBuExportError = action.error.message
            } else {
                state.startProcessKxBnpSapBuExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessKxBnpSapBuExport.pending, (state) => {
            state.loadUserParamsProcessKxBnpSapBuExportStatus = 'pending'
            state.loadUserParamsProcessKxBnpSapBuExportError = undefined
        })
        builder.addCase(loadUserParamsProcessKxBnpSapBuExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessKxBnpSapBuExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessKxBnpSapBuExport.rejected, (state, action) => {
            state.loadUserParamsProcessKxBnpSapBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessKxBnpSapBuExportError = action.error.message
            } else {
                state.loadUserParamsProcessKxBnpSapBuExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessKxBnpSapBuExport,
    resetstartProcessKxBnpSapBuExportError,
    resetloadUserParamsProcessKxBnpSapBuExport,
    resetloadUserParamsProcessKxBnpSapBuExportError,
    removeFromProcessKxBnpSapBuExportListById,
    removeFromProcessKxBnpSapBuExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessKxBnpSapBuExportSlice.actions
export default ProcessKxBnpSapBuExportSlice.reducer
